export class Settings
{
 static Energy=2;
 
}

export const Gravity={
    DENSITY_MIN : 611.5,
    DENSITY_MAX:1163.0,
    SG_MIN:0.6115,
    SG_MAX:1.164,
    API_MIN : -10.0,
    API_MAX:100.0,
}

export const VPSGravityType = {
    Density : 1,
    SG : 2,
    API : 3
}
export const EnergyUnit = {
    MJ_KG: 1,
    BTU_LB: 2,
    BTU_BBL: 3,
    BTU_GAL: 4,
    BTU_KCAL: 5
}

export const EnergyTypes = {
    energy_MJ_kg: "Energy in MJ/Kg",
    energy_Btu_lb: "Energy in Btu/lb",
    energy_Btu_bbl: "Energy in Btu/barrel",
    energy_Btu_gal: "Energy in Btu/gallon",
    energy_kCal_kg: "Energy in kCal/kg"
}
export const settings={
    FuelConstantA:9.4477,
    FuelConstantB:3.6116,
    Temperature:1,
    Viscocity:1

}
export const TempType = {
    celcius: 1,
    farenheit: 2
}

export const RatioType = {
    weight: 0,
    volume: 1
}

export const FuelConstant = {
    A: 9.4477,
    B: 3.6116
}

export const InfoType = {
    FlashPointRatioOnly: 0,
    NoVolumeValues: 1,
    NoWeightValues: 2,
    TargetConflict: 3,
    TargetInvalid: 4
}

export const PropertyType = {
    Density: 1,
    Viscosity: 2,
    FlashPoint: 3,
    Proportional: 4
};
export const ViscosityTypes={
    KinVisc50C: "Kinematic Viscosity at 50 \u00B0 C,mm2/s",
    Engler: "Degree Engler at 50 \u00B0 C,\u00B0 E",
    Redwood: "Redwood No.1 at 100 \u00B0 F,RW1",
    SSF: "Saybolt Furol at 100 \u00B0 F,SSF",
    SSU122: "Saybolt Universal at 122 \u00B0 F,SSU",
    SSU210: "Saybolt Universal at 210 \u00B0 F,SSU"
};

export const IsEnergyScreen = {
    flag: false
};
export const ParameterType =
{
    Gravity:0,
    Temperature:1,
    Pressure:2
} 